import { createSelector } from 'reselect';

const photoPointsSelector = state => state.reportState.photoPoints;
const hidePhotoPointsSelector = state => state.reportState.hidePhotoPoints;
const currentEventSelector = state => state.reportState.currentEvent;
const previousEventSelector = state => state.reportState.previousEvent;

export const sortedPhotoPointsSelector = createSelector(
    [photoPointsSelector],
    (photoPoints) => {
        return photoPoints.sort((a, b) => a.name.localeCompare(b.name, 'en', { numeric: true }));
    }
)

export const selectPhotoPointsWithPhotos = createSelector(
    [sortedPhotoPointsSelector, currentEventSelector, previousEventSelector, hidePhotoPointsSelector],
    (photoPoints, currentEvent, previousEvent, hidePhotoPoints) => {

        let figureNumber = 0;
        return photoPoints.map(photoPoint => {
            const currentPhoto = currentEvent?.Photos?.find( event => 
                event.photoPointId === photoPoint.photoPointId
                && event.sampleEventId === currentEvent.sampleEventId );
            const previousPhoto = previousEvent?.Photos?.find(event =>
                event.photoPointId === photoPoint.photoPointId
                && event.sampleEventId === previousEvent.sampleEventId );

            const {isCurrentHidden = false, isPreviousHidden = false} = hidePhotoPoints?.[photoPoint.photoPointId] ?? {};

            if (previousPhoto && !isPreviousHidden) {
                previousPhoto.figureNumber = ++figureNumber;
            }

            if (currentPhoto && !isCurrentHidden) {
                currentPhoto.figureNumber = ++figureNumber;
            }

            return {
                ...photoPoint,
                currentPhoto,
                previousPhoto,
            }
        })
    }
);

export const selectHidePhotoPointsById = (state, id) => {
    return hidePhotoPointsSelector(state)?.[String(id)] ?? null;
};

export const selectLastVisiblePhotoPointId = createSelector(
    [selectPhotoPointsWithPhotos, hidePhotoPointsSelector],
    (photoPoints, hidePhotoPoints) => {
        return (photoPoints ?? []).reduce((carry, photoPoint) => {
            const photoPointId = photoPoint.photoPointId;
            const {isCurrentHidden = false, isPreviousHidden = false} = hidePhotoPoints?.[photoPointId] ?? {};
            return ((photoPoint.currentPhoto && !isCurrentHidden) || (photoPoint.previousPhoto && !isPreviousHidden)) ? photoPointId : carry;
        }, null);
    }
);

export const selectNumberOfVisiblePhotoPoints = createSelector(
    [selectPhotoPointsWithPhotos, hidePhotoPointsSelector],
    (photoPoints, hidePhotoPoints) => {
        return (photoPoints ?? []).reduce((carry, photoPoint) => {
            const photoPointId = photoPoint.photoPointId;
            const {isCurrentHidden = false, isPreviousHidden = false} = hidePhotoPoints?.[photoPointId] ?? {};
            return carry + (((photoPoint.currentPhoto && !isCurrentHidden) || (photoPoint.previousPhoto && !isPreviousHidden)) ? 1 : 0);
        }, 0);
    }
);

